export const getMobileBackgroundFileId = (
  backgroundFileId?: number | null,
  mobileBackgroundFileId?: number | null,
) =>
  mobileBackgroundFileId !== undefined
    ? mobileBackgroundFileId
    : backgroundFileId
